import { useState } from "react";
import { useData } from "../../context/data-context";
import { AiFillStar, AiOutlineHeart, AiFillHeart } from "react-icons/ai";

export const ProductCard = ({ prod }) => {
  const [viewButton, setViewButton] = useState("noDisplay");
  const { state, dispatch } = useData();
  const { wishlist } = state;

  return (
    <div
      key={prod.id}
      onMouseEnter={() => setViewButton("display")}
      onMouseLeave={() => setViewButton("noDisplay")}
      className="product-card"
    >
      <div className="img-con">
        <img
          src={prod.thumbnail}
          alt={prod.title}
          className="prod-img prod-img-card"
        />

        {wishlist.some((p) => p.id === prod.id) ? (
          <AiFillHeart
            className="heart-icon heart-icon-fill"
            size={22}
            onClick={() =>
              dispatch({
                type: "REMOVE_FROM_WISHLIST",
                payload: prod,
              })
            }
          />
        ) : (
          <AiOutlineHeart
            className="heart-icon"
            size={22}
            onClick={() =>
              dispatch({
                type: "ADD_TO_WISHLIST",
                payload: {
                  id: prod.id,
                  title: prod.title,
                  thumbnail: prod.thumbnail,
                  price: prod.price,
                },
              })
            }
          />
        )}

        <button className={viewButton}>View Product</button>
      </div>
      <div className="card-body">
        <p className="prod-title">{prod.title}</p>
        <span className="highlight-text"> 
          <s className="grey-text">Rs. 599</s>
          Rs. {prod.price}
        </span>
        <p className="star grey-text">
          {[1, 2, 3, 4, 5].map((ele) => (
            <AiFillStar key={ele} className="rating" size={21} />
          ))}
          <small>(210)</small>
        </p>
      </div>
    </div>
  );
};
